import { tool as clientCreateAgentTool } from "@/shared/domain/agentThread/clientTools/clientCreateAgent";
import { stashPendingKickoff } from "@/shared/domain/agentThread/pendingKickoff";

/**
 * The person's first message in a thread started from "Build with chat" on
 * the agents list page, asking the model to work out the agent's design with
 * them.
 *
 * Written as the person's first turn rather than a system prompt because a
 * thread starts in `USER_TURN`: the model's first reply is the first thing the
 * person reads.
 */
const AGENT_BUILDER_KICKOFF_MESSAGE =
  "I'd like to build a reusable Agent template. Help me iterate on what " +
  "it should do: its name, description, optional model profile, kickoff " +
  "message, goals (dataset summary, or dataset triage with a label " +
  "vocabulary), and any variables the agent should accept at launch time. " +
  "Ask follow-up questions as needed. When we land on something concrete, " +
  "open the agent editor pre-filled with the draft so I can review and " +
  "save it.";

/**
 * What the model needs beside {@link AGENT_BUILDER_KICKOFF_MESSAGE}, which
 * the thread does not show: the tool that opens the agent editor, named from
 * the tool spec so a rename does not drift this prose out of sync.
 */
const AGENT_BUILDER_REQUEST_DETAILS =
  "To open the agent editor pre-filled with the draft, call " +
  `\`${clientCreateAgentTool.spec.name}\`.`;

/**
 * Stashes the agent-builder kickoff for the chat sidebar to start a thread
 * with. The caller opens the sidebar, since the collaboration bar is React
 * context state (`CreateAgentMenu` calls `useCollaborationBar().open`).
 */
export function stashAgentBuilderKickoff(): void {
  stashPendingKickoff({
    message: AGENT_BUILDER_KICKOFF_MESSAGE,
    requestDetails: AGENT_BUILDER_REQUEST_DETAILS,
  });
}
